<template>
  <div class="full-screen-bg">
    <dv-full-screen-container class="full-screen-container">
      <div class="full-screen-bg-img"></div>
      <HeaderBar />

      <div class="full-screen-content">
        <!-- left -->
        <div class="left-content">
          <div class="wrapper">
            <Order />
          </div>
          <div class="gap"></div>
          <div class="wrapper">
            <Merch />
          </div>
        </div>
        <!-- middle -->
        <div class="middle-content">
          <Statistic :items="topData" />
          <MapChart :items="mapData" />
          <Organ :items="organList" />
        </div>
        <!-- right -->
        <div class="right-content">
          <dv-border-box-8 class="echarts-wrapper" :reverse="true" :dur="4" backgroundColor="rgba(8, 50, 78, 0.6)">
            <PieChart :items="pieData" />
            <BarChart :items="mapData" />
          </dv-border-box-8>
          <div class="gap"></div>
          <VideoLive :videoData="videoData" />
        </div>
      </div>
    </dv-full-screen-container>
  </div>
</template>

<script lang="ts">
import BarChart from '@/components/BarChart.vue';
import HeaderBar from '@/components/HeaderBar.vue';
import MapChart from '@/components/MapChart.vue';
import Merch from '@/components/Merch.vue';
import Order from '@/components/Order.vue';
import Organ from '@/components/Organ.vue';
import PieChart from '@/components/PieChart.vue';
import Statistic from '@/components/Statistic.vue';
import VideoLive from '@/components/VideoLive.vue';

export default {
  name: 'home-view',
  components: {
    HeaderBar,
    Order,
    Merch,
    Statistic,
    Organ,
    VideoLive,
    PieChart,
    BarChart,
    MapChart,
  },

  data() {
    return {
      topData: [],
      videoData: {},
      organList: [],
      pieData: [],
      mapData: [],
      timerId: null,
    };
  },
  mounted() {
    console.log('Home mounted');
    this.loadSystemPromptInformations();

    // if (this.timerId) {
    //   clearInterval(this.timerId);
    // }
    // this.timerId = setInterval(() => {
    //   this.loadSystemPromptInformations();
    // },5000)
  },
  methods: {
    async loadSystemPromptInformations() {
      try {
        const { data } = await this.$http.get('/app-api/config/get-value-by-code?code=BigScreenData');
        const pdata = JSON.parse(data);
        console.log('==============================', pdata);
        const { topData, baseVideo, factoryVideo, organList, mapData, pieData } = pdata;
        // 顶部统计数据
        this.topData = topData;
        // 监控数据
        if (baseVideo && baseVideo.length > 0) {
          // eslint-disable-next-line vue/no-deprecated-delete-set
          this.$set(this.videoData, 'baseVideoUrl', baseVideo[0].url);
        }
        if (factoryVideo && factoryVideo.length > 0) {
          // eslint-disable-next-line vue/no-deprecated-delete-set
          this.$set(this.videoData, 'factoryVideoUrl', factoryVideo[0].url);
        }
        // 企业数据
        this.organList = organList;
        // 饼图数据
        this.pieData = pieData; // topData.filter((v) => v.title === '竹材' || v.title === '竹笋');
        // 地图数据
        this.mapData = mapData;
      } catch (error) {
        debugger;
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.full-screen-bg {
  background-color: #232630;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
}
.full-screen-container {
  width: 100%;
  height: 100%;
  .full-screen-bg-img {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: url(../../public/images/bg.jpg) no-repeat center/cover;
    filter: blur(5px);
    opacity: 0.4;
    z-index: -1;
  }
}

.full-screen-content {
  display: flex;
  width: 97%;
  margin: 0 auto;
  height: 85%;
  margin-top: 30px;
  flex-direction: row;
  .left-content,
  .right-content {
    width: 24%;
  }

  .left-content {
    display: flex;
    flex-direction: column;
    .gap {
      height: 20px;
    }
    .wrapper {
      width: 100%;
      flex: 1;
      overflow: hidden;
    }
  }
  .middle-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 0 20px;
    position: relative;
  }
  .right-content {
    display: flex;
    flex-direction: column;
    .gap {
      height: 20px;
    }
    .echarts-wrapper {
      flex: 2;
      display: flex;
    }
  }
}

::v-deep .echarts-wrapper .border-box-content {
  display: flex !important;
  flex-direction: column !important;
}
</style>
